import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
const PURCHASES = [{
  name: 'María',
  city: 'Ciudad de México, México'
}, {
  name: 'Florencia',
  city: 'Bogotá, Colombia'
}, {
  name: 'Valentina',
  city: 'Santiago, Chile'
}, {
  name: 'Camila',
  city: 'Lima, Perú'
}, {
  name: 'Sofía',
  city: 'Quito, Ecuador'
}, {
  name: 'Julieta',
  city: 'Buenos Aires, Argentina'
}, {
  name: 'Gabriela',
  city: 'Montevideo, Uruguay'
}, {
  name: 'Daniela',
  city: 'Guadalajara, México'
}, {
  name: 'Carolina',
  city: 'Medellín, Colombia'
}, {
  name: 'Andrea',
  city: 'San José, Costa Rica'
}, {
  name: 'Luciana',
  city: 'Panamá, Panamá'
}, {
  name: 'Romina',
  city: 'Santo Domingo, Rep. Dominicana'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(PURCHASES[0]);
  useEffect(() => {
    const initialTimeout = setTimeout(() => {
      showNextPopup();
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const showNextPopup = () => {
    const randomPurchase = PURCHASES[Math.floor(Math.random() * PURCHASES.length)];
    setCurrentPurchase(randomPurchase);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      const nextDelay = Math.floor(Math.random() * (15000 - 8000 + 1) + 8000);
      setTimeout(showNextPopup, nextDelay);
    }, 4000);
  };
  return <AnimatePresence data-id="element-242">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 max-w-sm w-[calc(100%-2rem)] md:w-auto cursor-pointer" onClick={() => document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    })} data-id="element-243">
          <div className="bg-yellow-950 rounded-lg shadow-2xl border border-yellow-800/50 px-4 py-3 flex items-center gap-3 relative" data-id="element-244">
            <span className="text-2xl flex-shrink-0" data-id="element-245">🏆</span>

            <p className="text-sm text-yellow-100" data-id="element-246">
              <strong className="text-yellow-400" data-id="element-247">
                {currentPurchase.name}
              </strong>{' '}
              de {currentPurchase.city} compró el{' '}
              <strong className="text-yellow-400" data-id="element-248">Pack Completo</strong>{' '}
              <span className="text-yellow-500" data-id="element-249">⭐</span>
            </p>

            <button onClick={e => {
          e.stopPropagation();
          setIsVisible(false);
        }} className="absolute -top-2 -right-2 bg-yellow-900 border border-yellow-800 rounded-full p-0.5 text-yellow-500 hover:text-yellow-300" data-id="element-250">
              <XIcon className="w-3 h-3" data-id="element-251" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}